import { initFolders } from './folders';
import { initFolder } from './folder';
import { initItems } from './items';
import { initItem } from './item';
import { initTrash } from './trash';
import { initItemsTrash } from './items.trash';
import { initItemsSiteMedia } from './items.site-media';
import { initFoldersTrash } from './folders.trash';
import { toItem } from './mappers/item';
import { defaultSettings } from './settings';
import { extendDeep, get } from '../../utils/utils';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
import { initRefreshTokenWrapper } from './refresh-token-wrapper';
import { initHttp } from '../../utils/http';
import { initPolling } from '../../services/polling';
import { initResumable } from '../../services/resumable';
import { initSocket } from './socket';
export function Private(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep(defaultSettings, userSettings);
  const withRefreshToken = initRefreshTokenWrapper(settings.refreshTokenUrl);
  const requestOptions = settings.requestOptions;
  if (get(requestOptions, 'params.ns')) {
    settings.ns = requestOptions.params.ns;
  }
  const channel = initSocket(settings, this, requestOptions);
  const http = initHttp(requestOptions);
  const polling = initPolling(settings, this, toItem, http);
  const resumable = initResumable(settings, this, toItem, http);
  const settingsWithRefreshToken = {
    get: withRefreshToken(http.get),
    post: withRefreshToken(http.post),
    upload: withRefreshToken(http.upload)
  };
  const httpWithRefreshToken = settings.refreshTokenUrl ? settingsWithRefreshToken : http;
  const folders = initFolders(settings, httpWithRefreshToken);
  const foldersTrash = initFoldersTrash(settings, httpWithRefreshToken);
  const folder = initFolder(settings, httpWithRefreshToken);
  const items = initItems(settings, httpWithRefreshToken);
  const itemsTrash = initItemsTrash(settings, httpWithRefreshToken);
  const itemsSiteMedia = initItemsSiteMedia(settings, httpWithRefreshToken);
  const item = initItem(settings, httpWithRefreshToken, channel, polling, resumable);
  const trash = initTrash(settings, httpWithRefreshToken);
  folders.trash = foldersTrash;
  items.trash = itemsTrash;
  items.siteMedia = itemsSiteMedia;
  this.name = 'private';
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.folder = addEvents(this, eventsList.FOLDER, folder);
  this.item = addEvents(this, eventsList.ITEM, item);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.trash = addEvents(this, eventsList.TRASH, trash);
}